require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/core-js/library/modules/es7.symbol.observable.js
// module id = 415
// module chunks = 0